import { render } from "./CerrrarGrupo.vue?vue&type=template&id=c55f3510&scoped=true"
import script from "./CerrrarGrupo.vue?vue&type=script&lang=js"
export * from "./CerrrarGrupo.vue?vue&type=script&lang=js"

import "./CerrrarGrupo.vue?vue&type=style&index=0&id=c55f3510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c55f3510"]])

export default __exports__